var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.contents),function(content){return (_vm.contents.length > 0)?_c('div',{key:content.id},[_c('ContentComponent',{attrs:{"contentItem":content}})],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }